<script setup lang="ts"></script>

<template>
  <div class="page">
    <router-link to="dev-login">去聊天</router-link>
  </div>
</template>
